import { NgModule } from "@angular/core";

import { TranslateModule, TranslateCompiler } from "@ngx-translate/core";

// these are private to cubiq-services intentionally
import { BasePricingService } from "../lookup/pricing/impl/BasePricingService";
import { DealtPricingService } from "../lookup/pricing/impl/DealtPricingService";
import { OrderTemperatureService } from "../lookup/pricing/impl/OrderTemperatureService";
import { DealPrivatizationService } from "../model/privatization/DealPrivatizationService";
import { OrderDataPrivatizationService } from "../model/privatization/OrderDataPrivatizationService";
import { CubiqSerializer } from "shared/cubiq-model-multi-asset";
import { AuthServicesModule } from "../../auth-services";

import {
  ConnectionStatusPromiseService,
  ConnectionStatusPrimaryService,
} from "shared/broker-client-services";

import { ClientModelPrivatization } from "../model/privatization/ClientModelPrivatization";
import { AccountModelPrivatization } from "../model/privatization/AccountModelPrivatization";
import { ClientTraderModelPrivatization } from "../model/privatization/ClientTraderModelPrivatization";
import { NotificationService } from "../lookup/notification/impl/NotificationService";
import { AlgoHedgeConfigService } from "../lookup/model/impl/AlgoHedgeConfigService";
import { JSONPointerCompiler } from "shared/ngx-translate";
import { UserAuthPrimaryService } from "../auth/impl/UserAuthPrimaryService";
import { UserAuthPromiseService } from "../auth/impl/UserAuthPromiseService";
import { ScratchPadDataActionPrimaryService } from "../action/impl/ScratchPadDataActionPrimaryService";
import { AllBenchmarksFixingStatusService } from "../action/impl/AllBenchmarksFixingStatusService";
import { AllBenchmarksFixingSummariesService } from "../action/impl/AllBenchmarksFixingSummariesService";
import { AllBenchmarksRequestService } from "../action/impl/AllBenchmarksRequestService";
import { ClientActionPrimaryService } from "../action/impl/ClientActionPrimaryService";
import { ClientActionPromiseService } from "../action/impl/ClientActionPromiseService";
import { DetailedOrderStatusRequestPrimaryService } from "../action/impl/DetailedOrderStatusRequestPrimaryService";
import { DetailedOrderStatusRequestPromiseService } from "../action/impl/DetailedOrderStatusRequestPromiseService";
import { FillTolerancePrimaryService } from "../action/impl/FillTolerancePrimaryService";
import { FillTolerancePromiseService } from "../action/impl/FillTolerancePromiseService";
import { FindActionPrimaryService } from "../action/impl/FindActionPrimaryService";
import { FindActionPromiseService } from "../action/impl/FindActionPromiseService";
import { ManualPriceActionPrimaryService } from "../action/impl/ManualPriceActionPrimaryService";
import { OpsIntPrimaryActionService } from "../action/impl/OpsIntPrimaryActionService";
import { OpsIntPromiseActionService } from "../action/impl/OpsIntPromiseActionService";
import { OrderAcceptancePrimaryService } from "../action/impl/OrderAcceptancePrimaryService";
import { OrderAcceptancePromiseService } from "../action/impl/OrderAcceptancePromiseService";
import { OrderDataActionPrimaryService } from "../action/impl/OrderDataActionPrimaryService";
import { OrderDataActionPromiseService } from "../action/impl/OrderDataActionPromiseService";
import { OrderQueryRequestPrimaryService } from "../action/impl/OrderQueryRequestPrimaryService";
import { OrderQueryRequestPromiseService } from "../action/impl/OrderQueryRequestPromiseService";
import { OrderSalesApprovalRequestPrimaryService } from "../action/impl/OrderSalesApprovalRequestPrimaryService";
import { OrderSalesApprovalRequestPromiseService } from "../action/impl/OrderSalesApprovalRequestPromiseService";
import { OrderXferPrimaryService } from "../action/impl/OrderXferPrimaryService";
import { OrderXferPromiseService } from "../action/impl/OrderXferPromiseService";
import { TradeDealPrimaryActionService } from "../action/impl/TradeDealPrimaryActionService";
import { TradeDealPromiseActionService } from "../action/impl/TradeDealPromiseActionService";
import { TradeQueryRequestPrimaryService } from "../action/impl/TradeQueryRequestPrimaryService";
import { TradeQueryRequestPromiseService } from "../action/impl/TradeQueryRequestPromiseService";
import { AccountLookupService } from "../lookup/model/impl/AccountLookupService";
import { AccountPrimaryLookupService } from "../lookup/model/impl/AccountPrimaryLookupService";
import { AccountPromiseLookupService } from "../lookup/model/impl/AccountPromiseLookupService";
import { AlgoStrategyLookupService } from "../lookup/model/impl/AlgoStrategyLookupService";
import { AlgoStrategyPrimaryLookupService } from "../lookup/model/impl/AlgoStrategyPrimaryLookupService";
import { AlgoStrategyPromiseLookupService } from "../lookup/model/impl/AlgoStrategyPromiseLookupService";
import { BenchmarkDataLookupService } from "../lookup/model/impl/BenchmarkDataLookupService";
import { BenchmarkDataPrimaryLookupService } from "../lookup/model/impl/BenchmarkDataPrimaryLookupService";
import { BenchmarkFixingLookupService } from "../lookup/model/impl/BenchmarkFixingLookupService";
import { BenchmarkFixingPrimaryLookupService } from "../lookup/model/impl/BenchmarkFixingPrimaryLookupService";
import { BlotterDefinitionLookupService } from "../lookup/model/impl/BlotterDefinitionLookupService";
import { BlotterDefinitionPrimaryLookupService } from "../lookup/model/impl/BlotterDefinitionPrimaryLookupService";
import { BlotterDefinitionPromiseLookupService } from "../lookup/model/impl/BlotterDefinitionPromiseLookupService";
import { BlotterFilterLookupService } from "../lookup/model/impl/BlotterFilterLookupService";
import { BlotterFilterPrimaryLookupService } from "../lookup/model/impl/BlotterFilterPrimaryLookupService";
import { BlotterFilterPromiseLookupService } from "../lookup/model/impl/BlotterFilterPromiseLookupService";
import { BranchLookupService } from "../lookup/model/impl/BranchLookupService";
import { BranchPrimaryLookupService } from "../lookup/model/impl/BranchPrimaryLookupService";
import { BranchPromiseLookupService } from "../lookup/model/impl/BranchPromiseLookupService";
import { CcyLookupService } from "../lookup/model/impl/CcyLookupService";
import { CcyPairLookupService } from "../lookup/model/impl/CcyPairLookupService";
import { CcyPairPrimaryLookupService } from "../lookup/model/impl/CcyPairPrimaryLookupService";
import { CcyPairPromiseLookupService } from "../lookup/model/impl/CcyPairPromiseLookupService";
import { CcyPrimaryLookupService } from "../lookup/model/impl/CcyPrimaryLookupService";
import { CcyPromiseLookupService } from "../lookup/model/impl/CcyPromiseLookupService";
import { ClientLookupService } from "../lookup/model/impl/ClientLookupService";
import { ClientPrimaryLookupService } from "../lookup/model/impl/ClientPrimaryLookupService";
import { ClientPromiseLookupService } from "../lookup/model/impl/ClientPromiseLookupService";
import { CurrencyPairCalendarLookupService } from "../lookup/model/impl/CurrencyPairCalendarLookupService";
import { CurrencyPairCalendarPrimaryLookupService } from "../lookup/model/impl/CurrencyPairCalendarPrimaryLookupService";
import { CurrencyPairCalendarPromiseLookupService } from "../lookup/model/impl/CurrencyPairCalendarPromiseLookupService";
import { CurrencyPairGroupLookupService } from "../lookup/model/impl/CurrencyPairGroupLookupService";
import { CurrencyPairGroupPrimaryLookupService } from "../lookup/model/impl/CurrencyPairGroupPrimaryLookupService";
import { CurrencyPairGroupPromiseLookupService } from "../lookup/model/impl/CurrencyPairGroupPromiseLookupService";
import { FixingSourceLookupService } from "../lookup/model/impl/FixingSourceLookupService";
import { FixingSourcePrimaryLookupService } from "../lookup/model/impl/FixingSourcePrimaryLookupService";
import { FixingSourcePromiseLookupService } from "../lookup/model/impl/FixingSourcePromiseLookupService";
import { HedgeOrderDataLookupService } from "../lookup/model/impl/HedgeOrderDataLookupService";
import { HedgeOrderDataPrimaryLookupService } from "../lookup/model/impl/HedgeOrderDataPrimaryLookupService";
import { InterventionDataLookupService } from "../lookup/model/impl/InterventionDataLookupService";
import { InterventionDataPrimaryLookupService } from "../lookup/model/impl/InterventionDataPrimaryLookupService";
import { InterventionDataPromiseLookupService } from "../lookup/model/impl/InterventionDataPromiseLookupService";
import { MarketTimeLookupService } from "../lookup/model/impl/MarketTimeLookupService";
import { MarketTimePrimaryLookupService } from "../lookup/model/impl/MarketTimePrimaryLookupService";
import { MarketTimePromiseLookupService } from "../lookup/model/impl/MarketTimePromiseLookupService";
import { OpsIntLookupService } from "../lookup/model/impl/OpsIntLookupService";
import { OpsIntPrimaryLookupService } from "../lookup/model/impl/OpsIntPrimaryLookupService";
import { OpsIntPromiseLookupService } from "../lookup/model/impl/OpsIntPromiseLookupService";
import { OrderDataLookupService } from "../lookup/model/impl/OrderDataLookupService";
import { OrderDataPrimaryLookupService } from "../lookup/model/impl/OrderDataPrimaryLookupService";
import { OrderDataPromiseLookupService } from "../lookup/model/impl/OrderDataPromiseLookupService";
import { PositionBookLookupService } from "../lookup/model/impl/PositionBookLookupService";
import { PositionBookPrimaryLookupService } from "../lookup/model/impl/PositionBookPrimaryLookupService";
import { PositionBookPromiseLookupService } from "../lookup/model/impl/PositionBookPromiseLookupService";
import { RateSourceLookupService } from "../lookup/model/impl/RateSourceLookupService";
import { RateSourcePrimaryLookupService } from "../lookup/model/impl/RateSourcePrimaryLookupService";
import { RateSourcePromiseLookupService } from "../lookup/model/impl/RateSourcePromiseLookupService";
import { SalesGroupLookupService } from "../lookup/model/impl/SalesGroupLookupService";
import { SalesGroupPrimaryLookupService } from "../lookup/model/impl/SalesGroupPrimaryLookupService";
import { SalesGroupPromiseLookupService } from "../lookup/model/impl/SalesGroupPromiseLookupService";
import { ScratchPadDataLookupService } from "../lookup/model/impl/ScratchPadDataLookupService";
import { ScratchPadDataPrimaryLookupService } from "../lookup/model/impl/ScratchPadDataPrimaryLookupService";
import { ScratchPadDataPromiseLookupService } from "../lookup/model/impl/ScratchPadDataPromiseLookupService";
import { SystemControlLookupService } from "../lookup/model/impl/SystemControlLookupService";
import { SystemControlPrimaryLookupService } from "../lookup/model/impl/SystemControlPrimaryLookupService";
import { SystemControlPromiseLookupService } from "../lookup/model/impl/SystemControlPromiseLookupService";
import { SystemMonitorLookupService } from "../lookup/model/impl/SystemMonitorLookupService";
import { TimezoneLookupService } from "../lookup/model/impl/TimezoneLookupService";
import { TimezonePrimaryLookupService } from "../lookup/model/impl/TimezonePrimaryLookupService";
import { TimezonePromiseLookupService } from "../lookup/model/impl/TimezonePromiseLookupService";
import {
  LimitClientTradeLookupService,
  AlgoClientTradeLookupService,
  BMClientTradeLookupService,
  NotificationTradeLookupService,
} from "../lookup/model/impl/TradeDealLookupService";
import {
  LimitClientTradePrimaryLookupService,
  AlgoClientTradePrimaryLookupService,
  BMClientTradePrimaryLookupService,
  TradeDealPrimaryLookupService,
} from "../lookup/model/impl/TradeDealPrimaryLookupService";
import { TradeDealPromiseLookupService } from "../lookup/model/impl/TradeDealPromiseLookupService";
import { NotificationTradeDealPrimaryLookupService } from "../lookup/model/impl/NotificationTradeDealPrimaryLookupService";
import { TraderGroupLookupService } from "../lookup/model/impl/TraderGroupLookupService";
import { TraderGroupPrimaryLookupService } from "../lookup/model/impl/TraderGroupPrimaryLookupService";
import { TraderGroupPromiseLookupService } from "../lookup/model/impl/TraderGroupPromiseLookupService";
import { UserLookupService } from "../lookup/model/impl/UserLookupService";
import { UserPrimaryLookupService } from "../lookup/model/impl/UserPrimaryLookupService";
import { UserPromiseLookupService } from "../lookup/model/impl/UserPromiseLookupService";
import { InflightAlertNotificationService } from "../lookup/notification/impl/InflightAlertNotificationService";
import { AccountDataAdapter } from "../mediator/adapter/AccountDataAdapter";
import { ClientAccountAdapter } from "../mediator/adapter/ClientAccountAdapter";
import { DetailFillOrderAdapter } from "../mediator/adapter/DetailFillOrderAdapter";
import { FindDealsDealAdapter } from "../mediator/adapter/FindDealsDealAdapter";
import { FindOrdersDataOrderAdapter } from "../mediator/adapter/FindOrdersDataOrderAdapter";
import { OrderAuditAdapter } from "../mediator/adapter/OrderAuditAdapter";
import { OrderRecapAdapter } from "../mediator/adapter/OrderRecapAdapter";
import { RawDataBmarkClientOrdersAdapter } from "../mediator/adapter/RawDataBmarkClientOrdersAdapter";
import { RawDataDealAdapter } from "../mediator/adapter/RawDataDealAdapter";
import { RawDataInterventionAdapter } from "../mediator/adapter/RawDataInterventionAdapter";
import { RawDataOpsIntAdapter } from "../mediator/adapter/RawDataOpsIntAdapter";
import { RawDataOrderAdapter } from "../mediator/adapter/RawDataOrderAdapter";
import { RawDataScratchPadAdapter } from "../mediator/adapter/RawDataScratchPadAdapter";
import { TradeDealAdapter } from "../mediator/adapter/TradeDealAdapter";
import { BfxBlotterOrdersContextMenuPrimaryService } from "../mediator/contextmenu/bfx-blotter-orders/impl/BfxBlotterOrdersContextMenuPrimaryService";
import { BfxBlotterOrdersContextMenuPromiseService } from "../mediator/contextmenu/bfx-blotter-orders/impl/BfxBlotterOrdersContextMenuPromiseService";
import { BfxFindOrdersContextMenuPrimaryService } from "../mediator/contextmenu/bfx-find-orders/impl/BfxFindOrdersContextMenuPrimaryService";
import { BfxFindOrdersContextMenuPromiseService } from "../mediator/contextmenu/bfx-find-orders/impl/BfxFindOrdersContextMenuPromiseService";
import { OrderAuditPrimaryService } from "../mediator/impl/OrderAuditPrimaryService";
import { OrderAuditPromiseService } from "../mediator/impl/OrderAuditPromiseService";
import { OrderRecapPrimaryService } from "../mediator/impl/OrderRecapPrimaryService";
import { OrderRecapPromiseService } from "../mediator/impl/OrderRecapPromiseService";
import { OrderSlippageService } from "../mediator/impl/OrderSlippageService";
import { TradeDealPrimaryService } from "../mediator/impl/TradeDealPrimaryService";
import { TradeDealPromiseService } from "../mediator/impl/TradeDealPromiseService";
import { VolumePerMinuteService } from "../mediator/impl/VolumePerMinuteService";
import { VwapPrimaryService } from "../mediator/impl/VwapPrimaryService";
import { VwapPromiseService } from "../mediator/impl/VwapPromiseService";
import { AtdlTooltipUiRep } from "../model/adtl/atdl-tooltip-ui-rep";
import { BmarkClientOrdersTableDefinitionFactory } from "../model/BmarkClientOrdersTableDefinitionFactory";
import { BmarkHedgeOrdersTableDefinitionFactory } from "../model/BmarkHedgeOrdersTableDefinitionFactory";
import { BmarkSpotRiskTableDefinitionFactory } from "../model/BmarkSpotRiskTableDefinitionFactory";
import { BmarkFwdRiskTableDefinitionFactory } from "../model/BmarkFwdRiskTableDefinitionFactory";
import { ConnectionMonitorAuditTableDefinitionFactory } from "../model/ConnectionMonitorAuditTableDefinitionFactory";
import { ConnectionMonitorConnectionsTableDefinitionFactory } from "../model/ConnectionMonitorConnectionsTableDefinitionFactory";
import { DetailFillTableDefinitionFactory } from "../model/DetailFillTableDefinitionFactory";
import { FindOrdersTableDefinitionFactory } from "../model/FindOrdersTableDefinitionFactory";
import { FindTradeTableDefinitionFactory } from "../model/FindTradeTableDefinitionFactory";
import { HedgeOrderMonitorStagingTableDefinitionFactory } from "../model/HedgeOrderMonitorStagingTableDefinitionFactory";
import { InboxTableDefinitionFactory } from "../model/InboxTableDefinitionFactory";
import { InterventionTableDefinitionFactory } from "../model/InterventionTableDefinitionFactory";
import { NotificationEventProcessorService } from "../model/notifications/NotificationEventProcessorService";
import { OpsIntTableDefinitionFactory } from "../model/OpsIntTableDefinitionFactory";
import { OrdersFilterModel } from "../model/OrdersFilterModel";
import { OrdersTableDefinitionFactory } from "../model/OrdersTableDefinitionFactory";
import { ClientAccountVisibilityService } from "../model/privatization/clientAccountVisibility/ClientAccountVisibilityService";
import { ScratchPadTableDefinitionFactory } from "../model/ScratchPadTableDefinitionFactory";
import { TradeTableDefinitionFactory } from "../model/TradeTableDefinitionFactory";
import { ProfilePrimaryActionService } from "../profile/impl/ProfilePrimaryActionService";
import { ProfilePromiseActionService } from "../profile/impl/ProfilePromiseActionService";
import { PublicProfilePrimaryActionService } from "../profile/impl/PublicProfilePrimaryActionService";
import { PublicProfilePromiseActionService } from "../profile/impl/PublicProfilePromiseActionService";
import { UserTemperatureService } from "../profile/impl/UserTemperatureService";
import { MarketDataEventTransformer } from "../rate/event/MarketDataEventTransformer";
import { MarkupPrimaryService } from "../rate/impl/MarkupPrimaryService";
import { MarkupPromiseService } from "../rate/impl/MarkupPromiseService";
import { OrderLifecycleRateSubscriptionSource } from "../rate/impl/OrderLifecycleRateSubscriptionSource";
import { RateCache } from "../rate/impl/RateCache";
import { RatePrimaryService } from "../rate/impl/RatePrimaryService";
import { RatePromiseService } from "../rate/impl/RatePromiseService";
import { RateSubscriptionPrimaryService } from "../rate/impl/RateSubscriptionPrimaryService";
import { RateSubscriptionPromiseService } from "../rate/impl/RateSubscriptionPromiseService";
import { SystemMessagePrimaryService } from "../system-message/impl/SystemMessagePrimaryService";
import { SystemMessagePromiseService } from "../system-message/impl/SystemMessagePromiseService";
import { CubiqWorker } from "../worker/CubiqWorker";
import { HeartBeatMonitor } from "../worker/HeartBeatMonitor";
import { CustomFieldLookupService } from "../lookup/model/impl/CustomFieldLookupService";
import { CustomFieldPrimaryLookupService } from "../lookup/model/impl/CustomFieldPrimaryLookupService";
import { CustomFieldPromiseLookupService } from "../lookup/model/impl/CustomFieldPromiseLookupService";
import { HubConnectionService } from "../model/HubConnectionService";
import { ClientAccountIsTradableService } from "../model/privatization/clientAccountVisibility/ClientAccountIsTradableService";
import { BenchmarkFixingCalendarLookupService as BenchmarkFixingCalendarLookupService } from "shared/cubiq-services/lookup/model/impl/FixingCalendarLookupService";
import { FwdRollPriceActionService } from "shared/cubiq-services/action/impl/FwdRollPriceActionService";
import { FwdRollOrdersTableDefinitionFactory } from "shared/cubiq-services/model/FwdRollOrdersTableDefinitionFactory";
import { FwdRollCurrencyTableDefinitionFactory } from "shared/cubiq-services/model/FwdRollCurrencyTableDefinitionFactory";
import { FwdRollDealtPairTableDefinitionFactory } from "shared/cubiq-services/model/FwdRollDealtPairTableDefinitionFactory";
import { OrderAuditTableDefinitionFactory } from "shared/cubiq-services/model/OrderAuditTableDefinitionFactory";
import { FixingAuditTableDefinitionFactory } from "shared/cubiq-services/model/FixingAuditTableDefinitionFactory";
import { BenchmarkPositionLookupService } from "../lookup/model/impl/BenchmarkPositionLookupService";
import { BenchmarkAuditLookupService } from "shared/cubiq-services/lookup/model/impl/BenchmarkAuditLookupService";
import { RiskTradeTableDefinitionFactory } from "../model/RiskTradeTableDefinitionFactory";
import {
  AlgoRiskTradeLookupService,
  BMRiskTradeLookupService,
  BMAlgoRiskTradeLookupService,
  LimitRiskTradeLookupService,
} from "../lookup/model/impl/RiskTradeLookupService";
import {
  AlgoRiskTradePrimaryLookupService,
  BMRiskTradePrimaryLookupService,
  BMAlgoTradePrimaryLookupService,
  LimitRiskTradePrimaryLookupService,
} from "../lookup/model/impl/RiskTradePrimaryLookupService";
import { AlgoRiskTradeTableDefinitionFactory } from "shared/cubiq-services/model/AlgoRiskTradeTableDefinitionFactory";
import { PlatformProfileLookupService } from "shared/cubiq-services/lookup/model/impl/PlatformProfileLookupService";
import { PlatformProfilePrimaryLookupService } from "shared/cubiq-services/lookup/model/impl/PlatformProfilePrimaryLookupService";
import { AllocationTableDefinitionFactory } from "shared/cubiq-services/model/AllocationTableDefinitionFactory";
import { ScratchPadOrderFactoryService } from "shared/cubiq-services/model/orders/ScratchPadOrderFactoryService";
import { AllocationBulkingService } from "shared/cubiq-services/action/impl/AllocationBulkingService";

@NgModule({
  imports: [
    TranslateModule.forChild({
      compiler: { provide: TranslateCompiler, useClass: JSONPointerCompiler },
    }),
    AuthServicesModule,
  ],

  providers: [
    CubiqWorker,
    HeartBeatMonitor,
    AccountLookupService,
    ClientLookupService,
    OrderDataLookupService,
    BenchmarkDataLookupService,
    HedgeOrderDataLookupService,
    ScratchPadDataLookupService,
    InterventionDataLookupService,
    OpsIntLookupService,
    SystemControlLookupService,
    TraderGroupLookupService,
    RateSourceLookupService,
    AlgoStrategyLookupService,
    FixingSourceLookupService,
    SalesGroupLookupService,
    BenchmarkFixingLookupService,
    BenchmarkFixingPrimaryLookupService,
    CcyLookupService,
    CcyPairLookupService,
    CurrencyPairGroupLookupService,
    CurrencyPairCalendarLookupService,
    BlotterDefinitionLookupService,
    BlotterFilterLookupService,
    UserLookupService,
    PositionBookLookupService,
    OrderAuditAdapter,
    OrderRecapAdapter,
    ClientAccountAdapter,
    AccountDataAdapter,
    MarketDataEventTransformer,
    RateCache,
    OrderLifecycleRateSubscriptionSource,
    FindOrdersDataOrderAdapter,
    FindDealsDealAdapter,
    RawDataOrderAdapter,
    RawDataScratchPadAdapter,
    RawDataDealAdapter,
    RawDataBmarkClientOrdersAdapter,
    RawDataInterventionAdapter,
    RawDataOpsIntAdapter,
    DetailFillOrderAdapter,
    FindOrdersTableDefinitionFactory,
    FindTradeTableDefinitionFactory,
    OrdersTableDefinitionFactory,
    OrdersFilterModel,

    InboxTableDefinitionFactory,
    ScratchPadTableDefinitionFactory,
    InterventionTableDefinitionFactory,
    OpsIntTableDefinitionFactory,
    ConnectionMonitorConnectionsTableDefinitionFactory,
    ConnectionMonitorAuditTableDefinitionFactory,
    BmarkClientOrdersTableDefinitionFactory,
    BmarkHedgeOrdersTableDefinitionFactory,
    BmarkSpotRiskTableDefinitionFactory,
    BmarkFwdRiskTableDefinitionFactory,
    HubConnectionService,
    TradeTableDefinitionFactory,
    RiskTradeTableDefinitionFactory,
    AlgoRiskTradeTableDefinitionFactory,
    AllocationTableDefinitionFactory,
    DetailFillTableDefinitionFactory,
    HedgeOrderMonitorStagingTableDefinitionFactory,
    FwdRollOrdersTableDefinitionFactory,
    FwdRollCurrencyTableDefinitionFactory,
    FwdRollDealtPairTableDefinitionFactory,
    OrderAuditTableDefinitionFactory,
    FixingAuditTableDefinitionFactory,
    AllBenchmarksRequestService,
    AllBenchmarksFixingStatusService,
    AllBenchmarksFixingSummariesService,
    BenchmarkFixingCalendarLookupService,
    {
      provide: AccountPromiseLookupService,
      useClass: AccountPrimaryLookupService,
    },
    {
      provide: ClientPromiseLookupService,
      useClass: ClientPrimaryLookupService,
    },
    {
      provide: BfxBlotterOrdersContextMenuPromiseService,
      useClass: BfxBlotterOrdersContextMenuPrimaryService,
    },
    {
      provide: BfxFindOrdersContextMenuPromiseService,
      useClass: BfxFindOrdersContextMenuPrimaryService,
    },
    { provide: OrderAuditPromiseService, useClass: OrderAuditPrimaryService },
    { provide: UserAuthPromiseService, useClass: UserAuthPrimaryService },
    {
      provide: RateSubscriptionPromiseService,
      useClass: RateSubscriptionPrimaryService,
    },
    { provide: MarkupPromiseService, useClass: MarkupPrimaryService },
    { provide: RatePromiseService, useClass: RatePrimaryService },
    {
      provide: DetailedOrderStatusRequestPrimaryService,
      useClass: DetailedOrderStatusRequestPrimaryService,
    },
    {
      provide: DetailedOrderStatusRequestPromiseService,
      useExisting: DetailedOrderStatusRequestPrimaryService,
    },
    {
      provide: ClientActionPromiseService,
      useClass: ClientActionPrimaryService,
    },
    {
      provide: OrderAcceptancePromiseService,
      useClass: OrderAcceptancePrimaryService,
    },
    {
      provide: OrderSalesApprovalRequestPromiseService,
      useClass: OrderSalesApprovalRequestPrimaryService,
    },
    { provide: OrderXferPromiseService, useClass: OrderXferPrimaryService },
    { provide: OrderRecapPromiseService, useClass: OrderRecapPrimaryService },
    {
      provide: OrderDataPrimaryLookupService,
      useClass: OrderDataPrimaryLookupService,
    },
    {
      provide: OrderDataPromiseLookupService,
      useExisting: OrderDataPrimaryLookupService,
    },
    {
      provide: BenchmarkDataPrimaryLookupService,
      useClass: BenchmarkDataPrimaryLookupService,
    },
    {
      provide: BenchmarkPositionLookupService,
      useClass: BenchmarkPositionLookupService,
    },
    {
      provide: HedgeOrderDataPrimaryLookupService,
      useClass: HedgeOrderDataPrimaryLookupService,
    },
    {
      provide: ScratchPadDataPrimaryLookupService,
      useClass: ScratchPadDataPrimaryLookupService,
    },
    {
      provide: ScratchPadDataPromiseLookupService,
      useExisting: ScratchPadDataPrimaryLookupService,
    },
    {
      provide: OrderQueryRequestPromiseService,
      useClass: OrderQueryRequestPrimaryService,
    },
    InterventionDataPrimaryLookupService,
    {
      provide: InterventionDataPromiseLookupService,
      useExisting: InterventionDataPrimaryLookupService,
    },
    OpsIntPrimaryLookupService,
    {
      provide: OpsIntPromiseLookupService,
      useExisting: OpsIntPrimaryLookupService,
    },
    {
      provide: SystemControlPromiseLookupService,
      useClass: SystemControlPrimaryLookupService,
    },
    {
      provide: TraderGroupPrimaryLookupService,
      useClass: TraderGroupPrimaryLookupService,
    },
    {
      provide: TraderGroupPromiseLookupService,
      useExisting: TraderGroupPrimaryLookupService,
    },
    {
      provide: RateSourcePromiseLookupService,
      useClass: RateSourcePrimaryLookupService,
    },
    {
      provide: AlgoStrategyPromiseLookupService,
      useClass: AlgoStrategyPrimaryLookupService,
    },
    {
      provide: FixingSourcePromiseLookupService,
      useClass: FixingSourcePrimaryLookupService,
    },
    {
      provide: SalesGroupPromiseLookupService,
      useClass: SalesGroupPrimaryLookupService,
    },
    { provide: CcyPromiseLookupService, useClass: CcyPrimaryLookupService },
    {
      provide: CcyPairPromiseLookupService,
      useClass: CcyPairPrimaryLookupService,
    },
    {
      provide: CurrencyPairGroupPromiseLookupService,
      useClass: CurrencyPairGroupPrimaryLookupService,
    },
    {
      provide: CurrencyPairCalendarPrimaryLookupService,
      useClass: CurrencyPairCalendarPrimaryLookupService,
    },
    {
      provide: CurrencyPairCalendarPromiseLookupService,
      useExisting: CurrencyPairCalendarPrimaryLookupService,
    },
    {
      provide: BlotterDefinitionPromiseLookupService,
      useClass: BlotterDefinitionPrimaryLookupService,
    },
    {
      provide: BlotterFilterPromiseLookupService,
      useClass: BlotterFilterPrimaryLookupService,
    },
    {
      provide: ProfilePromiseActionService,
      useClass: ProfilePrimaryActionService,
    },
    {
      provide: PublicProfilePromiseActionService,
      useClass: PublicProfilePrimaryActionService,
    },
    { provide: VwapPromiseService, useClass: VwapPrimaryService },

    { provide: UserPromiseLookupService, useClass: UserPrimaryLookupService },
    {
      provide: PositionBookPromiseLookupService,
      useClass: PositionBookPrimaryLookupService,
    },

    BranchLookupService,
    {
      provide: BranchPromiseLookupService,
      useClass: BranchPrimaryLookupService,
    },

    {
      provide: ConnectionStatusPromiseService,
      useClass: ConnectionStatusPrimaryService,
    },
    {
      provide: SystemMessagePromiseService,
      useClass: SystemMessagePrimaryService,
    },
    TimezoneLookupService,
    {
      provide: TimezonePromiseLookupService,
      useClass: TimezonePrimaryLookupService,
    },

    MarketTimeLookupService,
    {
      provide: MarketTimePromiseLookupService,
      useClass: MarketTimePrimaryLookupService,
    },
    OpsIntPrimaryActionService,
    {
      provide: OpsIntPrimaryActionService,
      useClass: OpsIntPrimaryActionService,
    },
    {
      provide: OpsIntPromiseActionService,
      useExisting: OpsIntPrimaryActionService,
    },

    TradeDealAdapter,
    { provide: TradeDealPromiseService, useClass: TradeDealPrimaryService },
    {
      provide: TradeDealPrimaryActionService,
      useClass: TradeDealPrimaryActionService,
    },
    {
      provide: TradeDealPromiseActionService,
      useExisting: TradeDealPrimaryActionService,
    },
    TradeQueryRequestPrimaryService,
    {
      provide: TradeQueryRequestPromiseService,
      useExisting: TradeQueryRequestPrimaryService,
    },
    LimitClientTradeLookupService,
    AlgoClientTradeLookupService,
    BMClientTradeLookupService,
    LimitClientTradePrimaryLookupService,
    AlgoClientTradePrimaryLookupService,
    BMClientTradePrimaryLookupService,
    {
      provide: TradeDealPrimaryLookupService,
      useExisting: LimitClientTradePrimaryLookupService,
    },

    {
      provide: TradeDealPromiseLookupService,
      useExisting: TradeDealPrimaryLookupService,
    },
    NotificationTradeLookupService,
    NotificationTradeDealPrimaryLookupService,
    LimitRiskTradeLookupService,
    AlgoRiskTradeLookupService,
    BMRiskTradeLookupService,
    BMAlgoRiskTradeLookupService,
    LimitRiskTradePrimaryLookupService,
    AlgoRiskTradePrimaryLookupService,
    BMRiskTradePrimaryLookupService,
    BMAlgoTradePrimaryLookupService,

    FindActionPrimaryService,
    { provide: FindActionPromiseService, useExisting: FindActionPrimaryService },

    {
      provide: OrderDataActionPromiseService,
      useClass: OrderDataActionPrimaryService,
    },

    ManualPriceActionPrimaryService,

    ScratchPadDataActionPrimaryService,

    BasePricingService,
    DealtPricingService,
    OrderTemperatureService,

    UserTemperatureService,
    DealPrivatizationService,
    AtdlTooltipUiRep,
    CustomFieldLookupService,
    CustomFieldPrimaryLookupService,
    {
      provide: CustomFieldPromiseLookupService,
      useExisting: CustomFieldPrimaryLookupService,
    },

    AlgoHedgeConfigService,
    OrderDataPrivatizationService,
    NotificationEventProcessorService,

    ClientModelPrivatization,
    AccountModelPrivatization,
    ClientTraderModelPrivatization,
    NotificationService,
    OrderQueryRequestPrimaryService,
    {
      provide: FillTolerancePromiseService,
      useClass: FillTolerancePrimaryService,
    },
    ClientAccountVisibilityService,
    {
      provide: ClientAccountIsTradableService,
      useExisting: ClientAccountVisibilityService,
    },
    SystemMonitorLookupService,
    InflightAlertNotificationService,
    VolumePerMinuteService,
    OrderSlippageService,

    FwdRollPriceActionService,
    BenchmarkAuditLookupService,
    PlatformProfileLookupService,
    PlatformProfilePrimaryLookupService,
    CubiqSerializer,
    ScratchPadOrderFactoryService,
    AllocationBulkingService,
  ],
})
export class CubiqServicesPrimaryModule {}
